import { list } from '../../../../../../common/classes/request-builder';

export class ProductosFitosanitariosListsDefinition {
    public fincas = list();

    public productos = list();

    public denominaciones_estandar = list();

    public denominaciones_otras = list();

    public familias = list(
        ['...', null], 
        'FITO (FITOSANITARIOS)', 
        'FITO1 (HERBICIDA)', 
        'FITO2 (COBRE)', 
        'FITO3 (NEMATICIDA)', 
        'FITO4 (HORMONAS)', 
        'FITO5 (INSECTICIDA)', 
        'FITO6 (FUNGICIDA)', 
        'FITO101 (MCPA)', 
        'FITO102 (HERBICIDA SELECTIVO)',
        'FITO501 (INSECTICISA SISTEMICO)',
        'FITO503 (INSECTICIDA - ACARICIDA)',
        'FITO504 (INSECTICIDA BIOLOGICO)',
        'FITO601 (FUNGICIDA SISTEMICO)',
        'FITO602 (FUNCICIDAD - ACARICIDA)',
        'FITO603 (FUNGICIDA - NEMATICIDA)'
    );

    public usos = list();

    public agentes = list();

    public empresas = list(['...', null]);

    public estado = list(['...', null], 'Activo', 'No Activo');

    public unidades = list(['...', null], 'unidades', 'sobres', 'sacos', 'toneladas', 'CC.', 'Gr.', 'Kilos', 'Litros,', 'ml');

    public unidades_costes = list(['...', null], 'Kilos', 'Litros');
}